import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import WhatsAppFloating from "../components/WhatsAppFloating";

const TermsPage = () => {
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
    <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Logo className="h-12 sm:h-14" />
            <Link to="/" className="text-sm text-neutral-600 hover:text-accent-600">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </header>
      {/* Hero */}
      <section className="bg-gradient-to-r from-accent-500 to-primary-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Términos y Condiciones
          </h1>
          <p className="text-xl text-white/90">
            Última actualización: Enero 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 prose prose-lg max-w-none">
          
          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">1. Aceptación de los Términos</h2>
            <p className="text-neutral-700 mb-4">
              Al acceder y utilizar SobreDigital ("el Servicio"), usted acepta estar sujeto a estos Términos y Condiciones. 
              Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestro servicio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">2. Descripción del Servicio</h2>
            <p className="text-neutral-700 mb-4">
              SobreDigital es una plataforma que permite a las parejas crear listas de regalos digitales para sus eventos. 
              Los invitados pueden seleccionar regalos de estas listas y realizar pagos que se depositan directamente en 
              la cuenta bancaria de la pareja.
            </p>
            <p className="text-neutral-700 mb-4">
              Nos reservamos el derecho de modificar o discontinuar el Servicio en cualquier momento, con o sin previo aviso.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">3. Registro y Cuenta</h2>
            <p className="text-neutral-700 mb-4">
              Para crear una lista de regalos, debe:
            </p>
            <ul className="list-disc pl-6 text-neutral-700 space-y-2 mb-4">
              <li>Completar el formulario de registro con información veraz y precisa</li>
              <li>Proporcionar datos bancarios válidos para recibir los pagos</li>
              <li>Mantener la confidencialidad de sus credenciales de acceso</li>
              <li>Notificar inmediatamente cualquier uso no autorizado de su cuenta</li>
            </ul>
            <p className="text-neutral-700 mb-4">
              Nos reservamos el derecho de rechazar cualquier solicitud de registro o suspender cuentas que violen estos términos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">4. Pagos y Comisiones</h2>
            <p className="text-neutral-700 mb-4">
              <strong>Setup Fee:</strong> Cobramos un cargo único de setup al momento de crear su lista de regalos.
            </p>
            <p className="text-neutral-700 mb-4">
              <strong>Sin comisiones sobre regalos:</strong> No cobramos ninguna comisión sobre los regalos recibidos. 
              Usted recibe el 100% del monto que sus invitados depositan.
            </p>
            {/* <p className="text-neutral-700 mb-4">
              <strong>Procesadores de pago:</strong> Los pagos son procesados por terceros (MercadoPago, PayPal, etc.). 
              Estos procesadores pueden aplicar sus propias comisiones según sus políticas.
            </p> */}
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">5. Responsabilidades del Usuario</h2>
            <p className="text-neutral-700 mb-4">
              Al usar nuestro servicio, usted se compromete a:
            </p>
            <ul className="list-disc pl-6 text-neutral-700 space-y-2 mb-4">
              <li>No utilizar el servicio para actividades ilegales o fraudulentas</li>
              <li>No intentar acceder a cuentas de otros usuarios</li>
              <li>Proporcionar información de contacto válida y actualizada</li>
              <li>Respetar los derechos de propiedad intelectual de SobreDigital y terceros</li>
              <li>Verificar que la información bancaria proporcionada sea correcta</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">6. Privacidad y Protección de Datos</h2>
            <p className="text-neutral-700 mb-4">
              Nos comprometemos a proteger su información personal de acuerdo con nuestra Política de Privacidad. 
              Al usar el Servicio, usted consiente la recopilación y uso de información según se describe en dicha política.
            </p>
            <p className="text-neutral-700 mb-4">
              Los datos bancarios son almacenados de forma segura y encriptada. No compartimos esta información con terceros 
              excepto cuando sea necesario para procesar pagos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">7. Reembolsos y Cancelaciones</h2>
            <p className="text-neutral-700 mb-4">
              <strong>Para parejas:</strong> El setup fee no es reembolsable una vez que la cuenta ha sido activada.
            </p>
            <p className="text-neutral-700 mb-4">
              <strong>Para invitados:</strong> Los regalos realizados no son reembolsables a través de SobreDigital. 
              Si tiene un problema con un pago, debe contactar directamente a la pareja o al procesador de pagos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">8. Limitación de Responsabilidad</h2>
            <p className="text-neutral-700 mb-4">
              SobreDigital actúa únicamente como intermediario entre parejas e invitados. No somos responsables por:
            </p>
            <ul className="list-disc pl-6 text-neutral-700 space-y-2 mb-4">
              <li>Disputas entre usuarios</li>
              <li>Información incorrecta proporcionada por los usuarios</li>
              <li>Fallos en los procesadores de pago de terceros</li>
              <li>Pérdida de acceso a cuentas por olvido de credenciales</li>
              <li>Demoras en la acreditación de fondos por parte de entidades bancarias</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">9. Propiedad Intelectual</h2>
            <p className="text-neutral-700 mb-4">
              Todo el contenido de SobreDigital, incluyendo diseño, logotipos, código y textos, es propiedad de SobreDigital 
              y está protegido por leyes de propiedad intelectual. No está permitido copiar, reproducir o distribuir 
              ningún contenido sin autorización previa por escrito.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">10. Modificaciones a los Términos</h2>
            <p className="text-neutral-700 mb-4">
              Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. 
              Los cambios entrarán en vigor inmediatamente después de su publicación en el sitio web. 
              Es su responsabilidad revisar periódicamente estos términos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">11. Ley Aplicable</h2>
            <p className="text-neutral-700 mb-4">
              Estos Términos y Condiciones se rigen por las leyes de la República Argentina. 
              Cualquier disputa será resuelta en los tribunales competentes de la Ciudad Autónoma de Buenos Aires.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">12. Contacto</h2>
            <p className="text-neutral-700 mb-4">
              Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos en:
            </p>
            <p className="text-neutral-700">
              Email: <a href="mailto:info@sobredigital.net" className="text-accent-600 hover:text-accent-700">info@sobredigital.net</a>
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-neutral-200">
            <p className="text-sm text-neutral-500 text-center">
              Última actualización: Enero 2026<br />
              © 2026 SobreDigital. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <WhatsAppFloating />
     <footer className="bg-white border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-center">
          <Link to="/" className="text-neutral-600 hover:text-accent-600 transition-colors">
            ← Volver al inicio
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
